import { BaseProps } from '@/components/types'
import '@/assets/scss/app/content.scss'
import { useMediaQuery } from '@mui/material'
import { MEDIA_QUERY } from '@/constants/style'
import { CSSProperties } from 'react'

function Content ( props: ContentProp ) {
    const {
        contentWidth, contentMinWidth = 420, fullWidth,
        mainHeight, contentHeight, contentPadding,
        children,
    } = props
    const matches = useMediaQuery( MEDIA_QUERY )
    const minWidth = screen.availWidth < contentMinWidth ? screen.availWidth : contentMinWidth
    const articleStyle: CSSProperties = { height: contentHeight }

    const getArticleStyle: () => CSSProperties = () => {
        if ( !matches ) {
            articleStyle.minWidth = minWidth,
            articleStyle.maxWidth = fullWidth ? screen.availWidth : screen.availWidth * ( contentWidth / 100 || 0.6 )
        }
        return articleStyle
    }

    return (
        <main style={ { height: mainHeight } }>
            <div
                className="content"
                style={ {
                    height: contentHeight,
                    padding: contentPadding
                } }
            >
                <article
                    className="content-wrapper"
                    style={ getArticleStyle() }
                >
                    { children }
                </article>
            </div>
        </main>
    )
}

export default Content

export interface ContentProp extends BaseProps {
    contentWidth?: number
    contentMinWidth?: number
    mainHeight?: string
    contentHeight?: string,
    contentPadding?: string,
    fullWidth?: boolean
}